import { ListUnis } from './hooks/use-list-unis'
import { ProductTierSku } from '@vendia/management-api-types'

export enum Tier {
  FREE = 'FREE', // TODO Remove once fully deprecated
  INDIVIDUAL = 'INDIVIDUAL',
  INDIVIDUAL_TRIAL = 'INDIVIDUAL_TRIAL',
  ENTERPRISE = 'ENTERPRISE',
  ENTERPRISE_TRIAL = 'ENTERPRISE_TRIAL',
}

export const getTierDisplayName = (tier: Tier, productTierSku?: ProductTierSku) => {
  // If productTierSku is set, use it for display name
  if (productTierSku) {
    const productTierToDisplay: Record<ProductTierSku, string> = {
      [ProductTierSku.Individual]: 'Free',
      [ProductTierSku.Pro]: 'Pro',
      [ProductTierSku.Enterprise]: 'Enterprise',
    }
    return productTierToDisplay[productTierSku]
  }

  const tierToDisplay = {
    FREE: 'Free account',
    INDIVIDUAL: 'Free account',
    INDIVIDUAL_TRIAL: 'Free account',
    ENTERPRISE: 'Enterprise',
    ENTERPRISE_TRIAL: 'Enterprise trial',
  }
  return tierToDisplay[tier]
}

export const TRIAL_TIERS = [Tier.FREE, Tier.INDIVIDUAL_TRIAL]

export const ENTERPRISE_TIERS = [Tier.ENTERPRISE, Tier.ENTERPRISE_TRIAL]

export const TRIAL_NODE_LIMIT = 3

export const getOwnedNodeCount = ({ unis, userId }: { unis: ListUnis; userId?: string }) => {
  let nodeCount = 0
  unis.forEach((uni) => {
    uni.nodes?.forEach((node) => {
      if (node.userId === userId) {
        nodeCount += 1
      }
    })
  })
  return nodeCount
}

export const isAtTrialNodeLimit = ({ unis, userId }: { unis: ListUnis; userId?: string }) => {
  return getOwnedNodeCount({ unis, userId }) >= TRIAL_NODE_LIMIT
}
